import { useEffect } from "react";
import { KEY_ESCAPE } from "src/constants/keyboard";

/**
 * Runs the callback when Escape key is pressed
 */
interface IUseEscapeKeyParams {
    callback: () => void;
    enabled?: boolean;
}

export function useEscapeKey({ callback, enabled = true }: IUseEscapeKeyParams) {
    useEffect(() => {
        if (!enabled) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === KEY_ESCAPE) {
                callback();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [callback, enabled]);
}
